import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'baseMinutesToHours',
})
@Injectable({ providedIn: 'root' })
export class BaseMinutesToHoursPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  /**
   * @param value minutes
   * @param showMinutes boolean – if true, always show minutes part if any (default: false)
   */
  transform(value: number, showMinutes: boolean = false): string {
    if (value == null || isNaN(value) || value < 0) return '';

    const hours = Math.floor(value / 60);
    const mins = value % 60;

    if (value < 60) {
      const minKey = mins === 1 ? 'relativeTime.minute' : 'relativeTime.minutes';
      return `${mins} ${this.translate.instant(minKey)}`;
    }

    let result = '';
    if (hours > 0) {
      const hourKey = hours === 1 ? 'relativeTime.hour' : 'relativeTime.hours';
      result += `${hours} ${this.translate.instant(hourKey)}`;
    }

    if (showMinutes && mins > 0) {
      result += ` ${mins} ${this.translate.instant(mins === 1 ? 'relativeTime.minute' : 'relativeTime.minutes')}`;
    }

    return result.trim();
  }
}
